<template>
    <form action="">
        <app-form-text-input
            label="Nombre"
            v-model="setting.name"
            :has-error="$v.setting.name.$error"
            error-message="Debe escribir el nombre de la configuración"
            :required="true"
        />
        <app-form-text-input
            label="Valor"
            v-model="setting.value"
            type="text"
            inputmode="decimal"
            pattern="^\d+(\.\d+)?$"
            :has-error="$v.setting.value.$error"
            error-message="Debe ingresar un valor válido (ej: 1.42, 1.00, 200)"
            required
            />

        <app-form-textarea-input
            label="Descripción"
            v-model="setting.description"
        />
    </form>
</template>
<script>
import FormTextInput from '../../../UI/Controls/Forms/FormTextInput.vue';
import FormTextareaInput from '../../../UI/Controls/Forms/FormTextareaInput.vue';
import itemsQuotationRepository from '../../../../repositories/items-quotation.repository';
import { required } from 'vuelidate/lib/validators';
import { decimal } from '../../../../utils/CustomValidators';

export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormTextareaInput: FormTextareaInput
    },
    props: {
        selectedSetting: {
            type: Object,
            default: null
        },
        onSave: {
            type: Function,
            default: () => false
        },
        id: {
            type: String,
            default: () => `quotation-setting-form-${parseInt(Math.random() * 10000000)}`
        }
    },
    data() {
        return {
            setting: {
                id: '',
                name: '',
                value: '',
                description: ''
            }
        };
    },
    watch: {
        selectedSetting(val) {
            if (val) {
                this.setting = {
                    id: val.id,
                    name: val.name || '',
                    value: val.value !== null && val.value !== undefined ? String(val.value) : '',
                    description: val.description || ''
                };
            }
        }
    },
    validations: {
        setting: {
            name: { required },
            value: { required, decimal }
        }
    },
    methods: {
        clear() {
            this.setting = {
                id: '',
                name: '',
                value: '',
                description: ''
            };
            this.$nextTick(() => {
                if (this.$v) {
                    this.$v.$reset();
                }
            });
        },
        saveSetting() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error('Por favor complete todos los campos requeridos');
                return;
            }

            const pr = { ...itemsQuotationRepository };
            const payload = { 
                ...this.setting,
                value: parseFloat(this.setting.value) || 0
            };

            const promise = this.setting.id
                ? pr.updateItemCategorySetting(payload, this.setting.id)
                : pr.saveItemCategorySetting(payload);

            promise
                .then(response => {
                    if (response && response.status) {
                        this.clear();
                        toastr.success(response.msg || 'Información guardada satisfactoriamente');
                        this.onSave();
                    } else {
                        toastr.error(response?.msg || 'Error al guardar la configuración');
                    }
                })
                .catch(error => {
                    toastr.error('Ocurrió un error al guardar la configuración');
                });
        }
    },
    created() {
        this.$bus.$on('quotation-setting-form.save', this.saveSetting);
        this.$bus.$on(`${this.id}.clear`, this.clear);
    },
    beforeDestroy() {
        this.$bus.$off('quotation-setting-form.save', this.saveSetting);
        this.$bus.$off(`${this.id}.clear`, this.clear);
    }
};
</script>

